import ActiveOptionViewState, { ActiveItem } from '../../store/schema/ActiveOptionViewState';
import loadSenderImageOption from '../../actions/senderImage/loadSenderImageOption';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';
import {
    getIsBitSet,
    ListViewBitFlagsMasks,
} from 'mini-options-store/lib/utils/listViewBitFlagsUtil';

const loadSenderImageOptionMutator = mutator(loadSenderImageOption, () => {
    getOptionsStore().activeViewState = {
        name: ActiveItem.SenderImage,
        isDirty: false,
        isLoading: false,
        isSenderImageEnabled: !getIsBitSet(ListViewBitFlagsMasks.HideSenderImage),
    } as ActiveOptionViewState;
});

export default loadSenderImageOptionMutator;
